import {BASE_ADMIN_API, fetchAPI} from '@/services/api';

/** Flat operation log row (session detail / legacy). */
export interface OperationLogVO {
    id?: number;
    userId?: number;
    username?: string;
    realName?: string;
    deptId?: number;
    deptName?: string;
    companyId?: number;
    companyName?: string;
    annualId?: number;
    ruleId?: number;
    pageName?: string;
    featureName?: string;
    ruleUrlPattern?: string;
    serviceName?: string;
    module?: string;
    action?: string;
    httpMethod?: string;
    requestUri?: string;
    success?: number;
    errorMsg?: string;
    costMs?: number;
    ipAddress?: string;
    loginToken?: string;
    ipLocation?: string;
    requestSummary?: string;
    createTime?: string;
}

/** Session-aggregated list row. */
export interface OperationLogSessionVO {
    loginToken?: string;
    /** 1 = historical row without login_token */
    legacy?: number;
    legacyId?: number;
    ipAddress?: string;
    ipLocation?: string;
    userId?: number;
    username?: string;
    realName?: string;
    companyId?: number;
    companyName?: string;
    loginTime?: string;
    lastActivityTime?: string;
    logoutTime?: string;
    opCount?: number;
    /** 1 when Logout op exists */
    closed?: number;
}

export interface OperationLogQueryBO {
    pageNum?: number;
    pageSize?: number;
    userId?: number;
    username?: string;
    companyId?: number;
    ruleId?: number;
    pageName?: string;
    featureName?: string;
    module?: string;
    action?: string;
    success?: number;
    startTime?: string;
    endTime?: string;
}

export interface OperationLogSessionOpsQueryBO {
    loginToken?: string;
    legacyId?: number;
}

export interface OperationLogPage {
    records: OperationLogVO[];
    total: number;
    size: number;
    current: number;
    pages: number;
}

export interface OperationLogSessionPage {
    records: OperationLogSessionVO[];
    total: number;
    size: number;
    current: number;
    pages: number;
}

const base = `${BASE_ADMIN_API}/operation-log`;

/** Stock flat page (kept for compatibility). */
export async function queryPage(query: OperationLogQueryBO) {
    return fetchAPI<OperationLogPage>(`${base}/queryPage`, {
        method: 'POST',
        body: JSON.stringify(query),
    });
}

/** Session-aggregated page for list UI. */
export async function querySessionPage(query: OperationLogQueryBO) {
    return fetchAPI<OperationLogSessionPage>(`${base}/querySessionPage`, {
        method: 'POST',
        body: JSON.stringify(query),
    });
}

/** Ops under one login session or one legacy id. */
export async function listSessionOps(query: OperationLogSessionOpsQueryBO) {
    return fetchAPI<OperationLogVO[]>(`${base}/sessionOps`, {
        method: 'POST',
        body: JSON.stringify(query),
    });
}

export async function getById(id: number) {
    return fetchAPI<OperationLogVO>(`${base}/get?id=${id}`, {method: 'GET'});
}

export const OperationLogService = {
    queryPage,
    querySessionPage,
    listSessionOps,
    getById,
};
